module.exports = __webpack_public_path__ + "ad1eca176120094a44912d1595515465.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/progressive_2023_chart.png
// module id = 1723
// module chunks = 0